import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAuth } from "firebase/auth";
import { authenticateUser } from "../../redux/reducers/UserReducer";
import ContentContainer from "../../components/ContentContainerComp/ContentContainer";
import Content from "../../components/PraticeComp/ContentComp/Content";
import ButtonRepeat from "../../assets/images/others/ButtonRepeat.png";
import s from "./style.module.css";

const testItem = {
  content_id: 16,
  label1: {
    text: "เก่งมากเลยครับน้องๆ",
    highlight: false,
  },
  label2: {
    text: "ด่านถัดไปเรามาเจอกันสัปดาห์หน้านะครับ",
    highlight: false,
  },
};
const AlertLogOutContainer = () => {
  const dispatch = useDispatch();
  const auth = getAuth();
  const userInfo = useSelector((state) => state.UserInfo);
  const logout = (e) => {
    auth.signOut().then((response) => {
      dispatch(authenticateUser({ ...userInfo }));
    });
    localStorage.removeItem("authUser");
  };
  return (
    <ContentContainer onCenter disableNext={1} disableBack={1}>
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Content contentID={99} item={testItem} />
          <img
            style={{ marginRight: "3vw" }}
            className={s.ButtonMenu}
            onClick={() => logout()}
            src={ButtonRepeat}
            alt="btnHome"
          />
        </div>
      </div>
    </ContentContainer>
  );
};

export default AlertLogOutContainer;
